export default {
  title: "Rogue",
  content: [
    "Wound Poison effect now reduces the target's healing received by 10%, stacking up to 5 times.",
    "Increased the value of Pick Pocketed items from rare enemies.",
  ],
};
